import * as React from 'react';
import { Typography, Box } from '@mui/material';
import Grid from '@mui/material/Grid';
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';

import { useTranslation } from "react-i18next";

var SI_SYMBOL = ["", "k", "M", "G", "T", "P", "E"];

function abbreviateNumber(number){

    // what tier? (determines SI symbol)
    var tier = Math.max(Math.log10(Math.abs(number)) / 3 | 0);

    // if zero, we don't need a suffix
    if(tier === 0) return number.toFixed(1).toLocaleString();

    // get suffix and determine scale
    var suffix = SI_SYMBOL[tier];
    var scale = Math.pow(10, tier * 3);

    // scale the number
    var scaled = number / scale;

    // format number and add suffix
    return scaled.toFixed(1).toLocaleString() + suffix;
}

export default function Savings(props) {

    const {totalCost, totalCostBaseline,
           totalConsumption, totalConsumptionBaseline,
           dateString, currencySymbol, carbonIntensity, title, tableSize, mega
        }  = props;

    const { t } = useTranslation();

    const carbonIntensityKG = carbonIntensity/1000.0;

    return (
        <Box display="flex" flexDirection={"column"} height="100%">
            {title !== ""? 
                <Typography component="h2" variant="h6" color="primary">
                    {title}
                </Typography>
                :
                null
            }
                <Box flex={0.75}/>
                <Grid container>
                    <Grid item xs={4}>
                        <Typography component="h2" variant="h7" align="center">
                        {currencySymbol} {totalCostBaseline? abbreviateNumber(totalCostBaseline - totalCost): ""}
                        </Typography>
                    </Grid>
                    <Grid item xs={4}>
                        <Typography component="h2" variant="h7" align="center">
                        {totalCostBaseline?((totalConsumptionBaseline - totalConsumption)/(mega? 1000.0 : 1.0)).toFixed(1).toLocaleString(): ""}
                        </Typography>
                        <Typography component="h2" variant="subtitle1" align="center">
                        {mega? "MWh": "KWh"}
                        </Typography>
                    </Grid>
                    <Grid item xs={4}>
                        <Typography component="h2" variant="h7" align="center">
                        {totalCostBaseline? ((totalConsumptionBaseline - totalConsumption)*carbonIntensityKG/(mega? 1000.0 : 1.0)).toFixed(1).toLocaleString(): ""}
                        </Typography>
                        <Typography component="h2" variant="subtitle1" align="center">
                        {mega? "T CO2" : "kg CO2"}
                        </Typography>
                    </Grid>
                </Grid>    
            {
                dateString !== ""?
                <Typography align={"right"} paddingRight={2}>
                    {t("OnDate", {date: dateString, interpolation: { escapeValue: false }})}
                </Typography>
                :
                null
            }        
            <Box flex={0.75}/>
            <TableContainer>
            <Table overflow="auto" size={tableSize} >
                <TableHead>
                <TableRow>
                        <TableCell align="right"></TableCell>
                        <TableCell align="center">{currencySymbol}</TableCell>
                        <TableCell align="center">{mega? "MWh": "KWh"}</TableCell>
                        <TableCell align="center">{mega? "T CO2" : "kg CO2"}</TableCell>
                    </TableRow>
                </TableHead>
                <TableBody>
                    <TableRow>
                        <TableCell align="right">{t("Baseline")}</TableCell>
                        <TableCell align="center">{totalCostBaseline? abbreviateNumber(totalCostBaseline) : ""}</TableCell>
                        <TableCell align="center">{totalCostBaseline? (totalConsumptionBaseline/(mega? 1000.0 : 1.0)).toFixed(1).toLocaleString(): ""}</TableCell>
                        <TableCell align="center">
                            {
                                totalCostBaseline?(totalConsumptionBaseline*carbonIntensityKG/(mega? 1000.0 : 1.0)).toFixed(1).toLocaleString(): ""
                            }
                        </TableCell>
                    </TableRow>
                    <TableRow>
                        <TableCell align="right">{t("Optimised")}</TableCell>
                        <TableCell align="center">{totalCostBaseline? abbreviateNumber(totalCost) : ""}</TableCell>
                        <TableCell align="center">{totalCostBaseline? (totalConsumption/(mega? 1000.0 : 1.0)).toFixed(1).toLocaleString(): ""}</TableCell>
                        <TableCell align="center">
                            {
                                totalCostBaseline?(totalConsumption*carbonIntensityKG/(mega? 1000.0 : 1.0)).toFixed(1).toLocaleString(): ""
                            }
                        </TableCell>
                    </TableRow>
                    <TableRow>
                        <TableCell align="right">{t("Savings")}</TableCell>
                        <TableCell align="center">{
                        totalCostBaseline? 
                        ((1.0 - totalCost.toFixed(2) / totalCostBaseline.toFixed(2))*100.0).toFixed(2)  + "%"
                        : ""
                        }</TableCell>
                        <TableCell align="center">{
                        totalCostBaseline? 
                        ((1.0 - totalConsumption.toFixed(2) / totalConsumptionBaseline.toFixed(2))*100.0).toFixed(2)  + "%"
                        : ""
                        }</TableCell>
                        <TableCell align="center">{
                        totalCostBaseline? 
                        ((1.0 - totalConsumption.toFixed(2) / totalConsumptionBaseline.toFixed(2))*100.0).toFixed(2) + "%"
                        : ""
                        }</TableCell>
                    </TableRow>
                </TableBody>
            </Table>
            </TableContainer>
            <Box flex={1}/>
        </Box>
    )

}